import React from "react";
import SolutionsItem from "../../components/SolutionItem";
import useFetch from "../../hooks/useFetch";
import './index.css'


const Solution = () => {
  const items = useFetch('http://1.94.62.64:9090/myf/getApplicationCases')

  return (
    <div className="flex flex-col">
      <div className="solution-image w-screen h-[500px] flex justify-center items-center space-x-4" />
      <div className="flex justify-center">
        <div className="grid grid-cols-3 my-20">
          {
            items?.length !== 0 ? items?.map((solution) => {
              return (
                <SolutionsItem
                  key={solution.id}
                  id={solution.id}
                  imgUrl={solution.picture}
                  header={solution.title}
                  readMeLink={`/solution/${solution.id}`}
                  introText={solution.content}
                />
              );
            })
              :
              <div className="text-4xl font-semibold my-72">敬请期待</div>
          }
        </div>
      </div>
    </div >
  );
};

export default Solution